import styles from './loading.page.module.css';
import LightningSpinner from '../../components/lightning-spinner/lightning-spinner';

const LoadingPage = () => {
  return (
    <div
      className={styles.wrapper}
    >
      <LightningSpinner />
    </div>
  );
}

export default LoadingPage;
